import PopUp from "../../components/popUp";
import { PurchaseResponseDTO } from "../../openapi-generated-client";
import { formatDate } from "../../utils/dateUtils";

interface PurchaseInfoPopUpProps {
    data: PurchaseResponseDTO;
    refetch?: () => void;
}

export default function PurchaseInfoPopUp(props: PurchaseInfoPopUpProps) {
    return <PopUp className="big" title="Purchase">
        <div className="columns">
            <div className="column left">
                <div className="grid-element">
                    <h4>Date</h4>
                    <p>{formatDate(new Date(props.data.date))}</p>
                </div>
                <div className="grid-element">
                    <h4>Buyer</h4>
                    <p>{props.data.accountName}</p>
                </div>
                <div className="grid-element">
                    <h4>Price</h4>
                    <p>{props.data.price} €</p>
                </div>
                <div className="grid-element">
                    <h4>Transaction Fees</h4>
                    <p>{props.data.transactionFees} €</p>
                </div>
            </div>
            <div className="column right">
                <div className="grid-element">
                    <h4>Piece</h4>
                    <p>{props.data.pieceName}</p>
                </div>
                <div className="grid-element">
                    <h4>Seller</h4>
                    <p>{props.data.composerName}</p>
                </div>
                <div className="grid-element">
                    <h4>Used Balance</h4>
                    <p>{props.data.usedBalance ? "Yes" : "No"}</p>
                </div>

            </div>
        </div>
    </PopUp>
}